"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Card = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var styles = {
  "Card": "Card__Card___1_26G",
  "Card--padding-default": "Card__Card--padding-default___xgDF9",
  "Card--padding-large": "Card__Card--padding-large___2KzUK",
  "Card--padding-none": "Card__Card--padding-none___1_Xu1",
  "Card--is-interactive": "Card__Card--is-interactive___3nFqr",
  "Card--is-selected": "Card__Card--is-selected___IBDSP"
};

var Card = function Card(_ref) {
  var _cn;

  var className = _ref.className,
      _ref$testId = _ref.testId,
      testId = _ref$testId === void 0 ? 'cf-ui-card' : _ref$testId,
      children = _ref.children,
      href = _ref.href,
      target = _ref.target,
      onClick = _ref.onClick,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? 'default' : _ref$padding,
      _ref$selected = _ref.selected,
      selected = _ref$selected === void 0 ? false : _ref$selected,
      ariaLabel = _ref.ariaLabel,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, ["className", "testId", "children", "href", "target", "onClick", "padding", "selected", "ariaLabel"]);
  var classNames = (0, _classnames["default"])(styles.Card, className, (_cn = {}, (0, _defineProperty2["default"])(_cn, styles["Card--padding-".concat(padding)], padding), (0, _defineProperty2["default"])(_cn, styles['Card--is-interactive'], onClick || href), (0, _defineProperty2["default"])(_cn, styles['Card--is-selected'], selected), _cn));
  var Element = href ? 'a' : 'div';
  var handleClick = onClick ? function (event) {
    return onClick(event);
  } : undefined;
  var handleKeyDown = onClick ? function (event) {
    if (event.nativeEvent.code === 'Enter' || event.nativeEvent.code === 'Space') {
      onClick(event);
      event.currentTarget.focus();
    }
  } : undefined;
  return /*#__PURE__*/_react["default"].createElement(Element, (0, _extends2["default"])({
    className: classNames,
    href: href,
    target: target,
    "data-test-id": testId,
    "aria-label": otherProps.title || ariaLabel,
    "aria-pressed": onClick ? selected ? 'true' : 'false' : undefined,
    tabIndex: onClick ? 0 : undefined,
    role: onClick ? 'button' : undefined,
    onClick: handleClick,
    onKeyDown: handleKeyDown
  }, otherProps), children);
};

exports.Card = Card;
var _default = Card;
exports["default"] = _default;